// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"93154a36ad01a3900de3","883":"9b5467f75124b4e47789"}[chunkId] + ".js";
};